import "react";
import { jsx as e } from "react/jsx-runtime";
import * as t from "@radix-ui/react-dropdown-menu";
//#region src/components/DropdownMenu/DropdownMenuRoot.tsx
var n = ({ allowScroll: n, modal: r, ...i }) => /* @__PURE__ */ e(t.Root, {
	modal: n ? !1 : r,
	...i
}), r = t.Trigger, i = t.Group, a = t.RadioGroup, o = t.Sub, s = t.Portal;
//#endregion
export { n as DropdownMenu, i as DropdownMenuGroup, s as DropdownMenuPortal, a as DropdownMenuRadioGroup, o as DropdownMenuSub, r as DropdownMenuTrigger };
